import lessonData from './lessons.json'
import type { Lesson } from '../types/lesson'

// JSON keeps daily content updates simple. The build-time validator checks the
// data before Vite imports it into the application.
export const lessons = [...(lessonData as unknown as Lesson[])].sort((a, b) =>
  b.publishedAt.localeCompare(a.publishedAt),
)

export const lessonBySlug = (slug: string) => lessons.find((lesson) => lesson.slug === slug)
